import { ICategoryMenu } from "../../model/respone/category/ICategoryMenu"
import { apiClient } from "../apiClient"

export const CATEGORY_MENU_API_RESOURCE = "category-menu"
export const categoryMenuApi = {
    SelectAll: () => apiClient.get(`${CATEGORY_MENU_API_RESOURCE}`),
    Insert: (payload: ICategoryMenu) => apiClient.post(`${CATEGORY_MENU_API_RESOURCE}`,payload),
    Update: (payload: ICategoryMenu) => apiClient.put(`${CATEGORY_MENU_API_RESOURCE}`,payload),
    Delete: (id: number) => apiClient.delete(`${CATEGORY_MENU_API_RESOURCE}/${id}`),
}

